module.exports = __webpack_public_path__ + "fonts/Roboto-MediumItalic.ttf?cf23e1bb619029496260760b72aebd30";